<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    华强路站<br>
站点介绍<br>
车站位于深圳市深南中路呈东西向布设。华强路站装修以白色为主，空间简洁明快，蓝色的立柱给人以自由舒爽的感觉，简单的材料组合及明亮的灯具，打造出富有现代气息的地下空间。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:13	23:58	1号线	2分钟	4分40秒<br>
机场东	06:30	23:10	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:14	23:56	1号线	3分45秒	5分45秒<br>
机场东	06:30	23:10	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:14	00:56	1号线	3分45秒	5分45秒<br>
机场东	06:30	00:10	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道北侧（东）、赛格广场、华强北路、华强北路地铁商业街<br><br>
B出入口:<br>
深南大道北侧（西）、中航路、深圳中心公园、田面新村、世纪汇购物中心、中航城君尚购物中心<br><br>
C出入口:<br>
深南大道南侧（西）、福虹路、中山大学附属第八医院、深圳市中医院、深圳市福田中学、北方大厦、汉国中心<br><br>
D出入口:<br>
深南大道南侧（东）、华强南路<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 上海宾馆东<br>
101、M106、M132、M192、高快巴士60<br><br>
B出入口:<br>
公交站名： 上海宾馆<br>
104、113、13、14、M102、204、215、223、3、62、377、M103、M112、M405、M190、M191、大鹏假日专线4号、高峰专线29<br><br>
C出入口:<br>
公交站名： 上海宾馆<br>
3、13、75、M103、104、113、M102、204、215、223、M112、14、377、M190、M191、62、高峰专线29、高快巴士6、大鹏假日专线4<br><br>
D出入口:<br>
公交站名： 华强路地铁接驳站<br>
E5、M405、高峰专线37、高快巴士6、M137、高峰专线91<br><br>
D出入口:<br>
公交站名： 上海宾馆东<br>
M106、M133、M192、M383、M405、高峰专线37、101、216、高快巴士60、M137<br><br>
D出入口:<br>
公交站名： 华强南<br>
13、23、B930<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>












